import { render, staticRenderFns } from "./AdminSchemaForm.vue?vue&type=template&id=711b40b3&"
import script from "./AdminSchemaForm.vue?vue&type=script&lang=js&"
export * from "./AdminSchemaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports